import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Landing from "./views/Landing.vue";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";

// bphtb
import Bphtb from "./views/bphtb/bphtb.vue";
import DaftarBphtb from "./views/bphtb/daftar.vue";
import FormBphtb from "./views/bphtb/form_inline.vue";

// auth
import ResetPassword from './views/auth/ResetPassword'
import ResetPasswordToken from './views/auth/ResetPasswordToken'

// QRcode
import Qrcode from './views/payment/qrcode'
import Vacode from './views/payment/vacode'


Vue.use(Router);

export default new Router({
    history: 'hash',
    linkExactActiveClass: "active",
    routes: [{
        path: "/",
        redirect: { name: 'home' }
    },
    {
        path: "/home",
        name: "home",
        components: {
            header: AppHeader,
            default: Home,
            footer: AppFooter
        }
    },
    {
        path: "/landing",
        name: "landing",
        components: {
            header: AppHeader,
            default: Landing,
            footer: AppFooter
        }
    },
    {
        path: "/bphtb",
        name: "bphtb",
        components: {
            header: AppHeader,
            default: Bphtb,
            footer: AppFooter
        }
    },
    {
        path: "/bphtb/daftar",
        name: "bphtb_daftar",
        components: {
            header: AppHeader,
            default: DaftarBphtb,
            footer: AppFooter
        }
    },
    {
        path: "/bphtb/from-daftar",
        name: "from_bphtb_daftar",
        components: {
            header: AppHeader,
            default: FormBphtb,
            footer: AppFooter
        }
    },
    {
        path: "/bphtb/from-update/:id",
        name: "from_bphtb_update",
        components: {
            header: AppHeader,
            default: FormBphtb,
            footer: AppFooter
        },
        props: true,

    },
    {
        path: "/register",
        name: "register",
        components: {
            header: AppHeader,
            default: Register,
            footer: AppFooter
        }
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        components: {
            header: AppHeader,
            default: ResetPassword,
            footer: AppFooter
        }
    },
    {
        path: "/reset-password/:token",
        name: "ResetPasswordToken",
        components: {
            header: AppHeader,
            default: ResetPasswordToken,
            footer: AppFooter
        }
    },
    {
        path: "/payment/qrcode/:id",
        name: "Qrcode",
        components: {
            header: AppHeader,
            default: Qrcode,
            footer: AppFooter
        }
    },
    {
        path: "/payment/vacode/:id",
        name: "Vacode",
        components: {
            header: AppHeader,
            default: Vacode,
            footer: AppFooter
        }
    }
    ],
    scrollBehavior: (to, from, savedPosition) => {
        return new Promise((resolve, reject) => {
            if(savedPosition) {
                // create an Observer instance
                const resizeObserver = new ResizeObserver(entries => {
                    if(entries[0].target.clientHeight >= savedPosition.top + screen.height) {
                        resolve(savedPosition);
                        resizeObserver.disconnect();
                    }
                });
                
                // start observing a DOM node
                resizeObserver.observe(document.body);
            } else {
                resolve({ top: 0 });
            }
        });
    }
});